"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.environmentIsValid = exports.getEnvironments = void 0;
var environments_1 = require("../configs/environments");
/**
 * Get an array of all available environments.
 */
var getEnvironments = function () { return Object.values(environments_1.Environment); };
exports.getEnvironments = getEnvironments;
/**
 * Check whether the given environment is valid, meaning that
 * it is included in the available environments.
 */
var environmentIsValid = function (environment) {
    return (0, exports.getEnvironments)().includes(environment);
};
exports.environmentIsValid = environmentIsValid;
